var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    { staticClass: "stage__row" },
    [
      _c("StageName", {
        attrs: { stage: _vm.stage },
        on: {
          update: (stageName) =>
            _vm.updateStage(_vm.stage.getId(), "name", stageName),
          delete: function ($event) {
            _vm.$emit("delete", _vm.stage.getId())
          },
        },
      }),
      _vm._v(" "),
      _c("StageRelated", {
        attrs: { stages: _vm.stages, stage: _vm.stage },
        on: {
          update: (stageRelated) =>
            _vm.updateStage(_vm.stage.getId(), "relatedStageId", stageRelated),
        },
      }),
      _vm._v(" "),
      _c("StageResponsible", {
        attrs: { responsibleUserId: _vm.stage.responsible },
        on: {
          update: (stageResponsible) =>
            _vm.updateStage(_vm.stage.getId(), "responsible", stageResponsible),
        },
      }),
      _vm._v(" "),
      _c("StageDuration", {
        attrs: { stage: _vm.stage },
        on: {
          update: (stageDuration) =>
            _vm.updateStage(_vm.stage.getId(), "duration", stageDuration),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }